import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../styles/graduation.css';
import confetti from 'canvas-confetti';
import sound from '../assets/dark-future-logo.mp3';
import ics from '../assets/Idna‘s Geburtstagsfeier.ics'

function GraduationCard(props) {
    const soundEffect = new Audio();
    soundEffect.autoplay = true;

    const [isOpen, setIsOpen] = useState(false);
    const { name = '' } = useParams();
    const [showButtons, setShowButtons] = useState(false);


    const handleCardClick = () => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            soundEffect.src = sound;
            soundEffect.play();
            setTimeout(() => {
                triggerConfetti();
                resetAnimation();
            }, 2000);
            setTimeout(() => {

                setShowButtons(true);
            }, 6000);

        } else {
            setShowButtons(false);
        }
    };

    const triggerConfetti = () => {
        confetti({
            particleCount: 200,
            spread: 90,
            origin: { x: 0.5, y: 0.5 },
            colors: ['#d0d01d', '#0a3fb0', '#9a0f93', '#1e1e28'],
        });
    };

    const resetAnimation = () => {
        const textElements = document.querySelectorAll('.card-content h2, .card-content p');
        textElements.forEach(element => {
            element.classList.remove('active');
            void element.offsetWidth;
            element.classList.add('active');
        });
    };

    const handleSocialClick = (message) => {
        const url = `https://ig.me/m/idna001?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    const handleICalClick = () => {
        window.open(ics, '_blank');
    };

    return (
        <div className="graduation-container">
            <Helmet>
                <title>{ props.metatitle }</title>
                <meta name="description" content={ props.metadescription } />
                <meta property="og:title" content={ props.metatitle } />
                <meta property="og:description" content={ props.metadescription } />
            </Helmet>
            <div className="paragraphs-background">
                <div className="paragraph p1">§</div>
                <div className="paragraph p2">§</div>
                <div className="paragraph p3">§</div>
                <div className="paragraph p4">§</div>
                <div className="paragraph p5">§</div>
                <div className="paragraph p6">§</div>
                <div className="paragraph p7">§</div>
                <div className="paragraph p8">§</div>
                <div className="paragraph p9">§</div>
                <div className="paragraph p10">§</div>
            </div>


            <div
                className={`graduation-card ${isOpen ? 'open' : ''}`}
                onClick={handleCardClick}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && handleCardClick()}
            >
                <div className="graduation-card-cover">

                    <h2>Hey {name}</h2>

                    <h2>🎓 You are invited! 🎓</h2>
                    <p>{props.description}</p>
                </div>
                <div className={`graduation-card-content ${isOpen ? 'active' : ''}`}>
                    <h2 dangerouslySetInnerHTML={{__html: props.heading}}></h2>
                    <p>
                        when: <strong>{props.date}</strong> <br/>
                        where: <strong>{props.location}</strong> <br/>
                        theme: <strong>{props.theme}</strong>

                    </p>
                    <p dangerouslySetInnerHTML={{__html: props.message}}></p>

                    {showButtons && (
                        <div>
                            <p className={'graduation-disclaimer'}>{props.disclaimer}</p>
                            <div className="graduation-button-container">
                                <button className="graduation-neon-button"
                                        onClick={() => handleSocialClick('Hi, ich bin dabei!')}>
                                    Count me in
                                </button>
                                <button className="graduation-neon-button dark"
                                        onClick={() => handleSocialClick('Hi, ich kann leider nicht kommen!')}>
                                    Can’t make it

                                </button>
                            </div>
                            <button className="graduation-calender-button" onClick={handleICalClick}>
                                <span className="icon">📆</span> add to calendar
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default GraduationCard;